export default "/bundles/assets/photoBlank_76c585725e8b255cce325556118284c1.png";